import { render } from "./orderSign.vue?vue&type=template&id=26a64052&scoped=true&lang=html"
import script from "./orderSign.vue?vue&type=script&lang=js"
export * from "./orderSign.vue?vue&type=script&lang=js"

import "./orderSign.vue?vue&type=style&index=0&id=26a64052&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a64052"]])

export default __exports__